import axios from "axios"

const UPLOAD_IMAGE_URL = process.env.VUE_APP_UPLOAD_IMAGE_URL
const CROP_IMAGE_URL = process.env.VUE_APP_CROP_IMAGE_URL

export default {
  uploadImage(ref, file) {
    const data = new FormData()
    data.append("image", file, ref)
    const config = {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    }
    return axios
      .post(UPLOAD_IMAGE_URL, data, config)
      .then(response => response.data)
      .catch(error => {
        if (error.response && error.response.status) {
          switch (error.response.status) {
            case 0:
              throw new Error("offline")
            case 413:
              throw new Error("fileTooBig")
          }
        }
        throw error
      })
  },

  cropImage(url, cropData) {
    return axios
      .get(CROP_IMAGE_URL, {
        params: {
          url,
          cropData
        }
      })
      .then(response => response.data)
      .catch(error => {
        if (error.response && error.response.status) {
          switch (error.response.status) {
            case 0:
              throw new Error("offline")
          }
        }
        throw error
      })
  }
}
